<template>
  <div id="page" class="container-fluid">
    <div class="col mt-3">
      <b-alert v-if="generalErrorMessage" :show="true" fade variant="danger">
        {{ generalErrorMessage }}
      </b-alert>
    </div>
    <div class="row header ml-4 my-4">
      <div class="col my-3">
      <div v-if="selfPayBundles === false">
        <h1>{{title}} Episodes <b-button class="ml-3" variant="outline-orange" @click="addBundle()">
          <font-awesome-icon class="orange" icon="plus"/>
          New
        </b-button>
          <img v-if="selectedEmployerId > 0 && employer && employer.logoUrl" class="employer-logo ml-3" :src="employer.logoUrl"></h1>
      </div>
      <div v-if="selfPayBundles === true">
        <h1>{{title}} Episodes <b-button class="ml-3" variant="outline-orange" @click="addBundle()">
          <font-awesome-icon class="orange" icon="plus"/>
          New
        </b-button></h1>
      </div>
      </div>
      <div class="col filter-row text-right mr-2">
        <div class="patient-search-section mr-2">
          <b-input-group class="patient-search-border text-right">
            <b-form-input ref="searchInput"
                          placeholder="Search (Episode Code)"
                          class="patient-search"
                          v-model="searchTerm"></b-form-input>
            <b-input-group-append>
              <button class="btn btn-default patient-search-submit" type="button">
                <font-awesome-icon icon="search"/>
              </button>
            </b-input-group-append>
          </b-input-group>
        </div>
      <b-btn @click.stop="libraryPopoverShowing = !libraryPopoverShowing"
             id="visit-statuses" variant="outline-orange">
        <font-awesome-icon class="orange mr-2" :icon="[ 'far', 'bars-progress' ]"/>Episode Library
      </b-btn>
      <b-popover :show.sync="libraryPopoverShowing"
                 target="visit-statuses" placement="bottomleft" triggers="">
        <b-form-group v-click-outside="hideLibraryPopover" class="status-popover" label="Episode Library">
          <b-form-radio-group stacked v-model="selectedEmployerId" @change="selectEpisodeLibrary()" name="episodeLibrary" :options="employerOptions">
          </b-form-radio-group>
        </b-form-group>
      </b-popover>
      </div>
    </div>
    <div  class="container-fluid">
      <div class="row data-table-header">
        <div class="col-2"><a href="#" @click.prevent="sort('EpisodeName')">Episode Name {{ sortIndicator ('EpisodeName') }}</a></div>
        <div class="col-1"><a href="#" @click.prevent="sort('EpisodicCode')">Episodic Codes {{ sortIndicator ('EpisodicCode') }}</a></div>
        <div class="col-1"><a href="#" @click.prevent="sort('EpisodicTerm')">Episodic Term {{ sortIndicator ('EpisodicTerm') }}</a></div>
        <div class="col-2"><a href="#" @click.prevent="sort('ProviderDescription')">Provider Description {{ sortIndicator ('ProviderDescription') }}</a></div>
        <template v-if="selectedEmployerId > 0 && employer">
        <div class="col-1"><a href="#" @click.prevent="sort('Status')">Status {{ sortIndicator ('Status') }}</a></div>
        <div class="col-1"><a href="#" @click.prevent="sort('Amount')">Amount {{ sortIndicator ('Amount') }}</a></div>
        <div class="col-4"></div>
        </template>
        <template v-if="selectedEmployerId === -1">
          <div class="col-2"><a href="#" @click.prevent="sort('Amount')">Amount {{ sortIndicator ('Amount') }}</a></div>
          <div class="col-4"></div>
        </template>
      </div>
      <div v-for="bundle in bundles" v-if="bundle.status !== 'Archived'" class="row data-table-row" :key="bundle.organizationBundleId">
        <div class="column col-2">{{ bundle.name }}</div>
        <div class="column col-1"><b>{{ displayCode(bundle) }}</b>
        <div v-for="(code, index) in bundle.codes" v-if="bundle.codes" :key="'code-' + index">{{code.code}}</div>
        </div>
        <div class="column col-1">{{ displayTerm(bundle) }}</div>
        <div class="column col-2">{{ bundle.description }}</div>
        <template v-if="selectedEmployerId > 0 && employer">
        <div class="column col-1">{{ bundle.status === 'PendingApproval' ? 'Pending Approval' : bundle.status }}</div>
        <div class="column col-1">${{ formatNumber(bundle.amount) }}</div>
        </template>
        <template v-if="selectedEmployerId === -1">
          <div class="column col-2">${{ formatNumber(bundle.amount) }}</div>
        </template>
        <div class="column col-4 text-right">
          <button name="edit" class="btn btn-outline-orange mr-2" @click.prevent="editBundle(bundle)">
            <font-awesome-icon class="orange mr-1" :icon="['far', 'edit']"/>
            Edit
          </button>
          <button @click.prevent="editBundleServices(bundle)" class="btn btn-outline-orange  mr-2">
            <font-awesome-icon class="orange mr-1" :icon="['far', 'clipboard-medical']"/>
            Services
          </button>
          <button v-if="bundle.bundleType === 'Employer' && bundle.status === 'Draft' || bundle.status === 'Denied'" @click.prevent="publishBundle(bundle)" class="btn btn-outline-orange mr-2">
            <font-awesome-icon class="orange mr-1" :icon="['far', 'upload']"/>
            Publish
          </button>
          <button v-if="bundle.patientAmount || bundle.patientPaymentType === 'MaxOOP' && bundle.bundleType === 'Employer' || bundle.status === 'Denied'" class="btn btn-outline-orange mr-2" @click.prevent="editBundleInsurancePatientAmounts(bundle)">
            <font-awesome-icon class="orange mr-1" :icon="['far', 'message-dollar']"/>
            Patient Cost
          </button>
          <button v-if="bundle.bundleType === 'Employer' && bundle.status !== 'Draft'" @click.prevent="confirmArchive(bundle)" class="btn btn-outline-orange mr-2">
            <font-awesome-icon class="orange mr-1" :icon="['far', 'box-archive']"/>
            Archive
          </button>
        </div>
      </div>
    </div>

    <div class="alert alert-secondary" role="alert" v-show="!bundles.length && !generalErrorMessage">
      &nbsp;&nbsp;No bundles have been configured.
    </div>

    <div class="row justify-content-center m-2">
      <div class="alert alert-danger col-6" role="alert" v-show="generalErrorMessage">
        {{ generalErrorMessage }}
      </div>
    </div>
    <confirm-modal @confirmed="archiveConfirmed" class="align-middle"
                   confirmButton="Archive"
                   title= "Archive Episode"
                   :visible="showingConfirmModal"
                   @update:visible="visible => showingConfirmModal = visible">
      <div class="row mb-3">
        <div class="col-2"></div>
        <div class="col-8 mt-2 text-center">
          <div class="text-left"><font-awesome-icon size="sm" class="text-warning mr-2" icon="exclamation-triangle"/>By selecting <b>“Archive”</b> you will remove this episode from the published library, thereby archiving the episode for future use. Please click <b>“Archive”</b> to confirm.</div></div>
        <div class="col-2"></div>
      </div>
    </confirm-modal>
    <loading-modal :visible="showingLoadingModal" :return-focus="$refs.searchInput"
                   @update:visible="visible => showingLoadingModal = visible"></loading-modal>
    <paginator :totalPages="totalPages" :currentPage="currentPage"
               @update:currentPage="newPage => currentPage = newPage"></paginator>
    <bundle-modal :visible="showingBundleModal" :edit-bundle="editingBundle" :bundle-type="bundleType" :employer-id="selectedEmployerId" :employer="employer" @update:visible="visible => showingBundleModal = visible" @bundleSaved="bundleSaved()"></bundle-modal>
    <bundle-services-modal :title="episodeServiceModalTitle" :visible="showingServicesModal" :bundle-id="editingBundle.organizationBundleId" @update:visible="visible => showingServicesModal = visible" @closeModal="serviceSaved()"></bundle-services-modal>
    <bundle-insurance-patient-amount-modal :visible="showingBundleInsurancePatientAmountModal" :bundle-id="editingBundle.organizationBundleId" @update:visible="visible => showingBundleInsurancePatientAmountModal = visible" @closeModal="insurancePatientAmountSaved()"></bundle-insurance-patient-amount-modal>
  </div>
</template>

<script>
  import LoadingModal from '@/components/LoadingModal'
  import Paginator from '@/components/Paginator'
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import moment from 'moment-timezone'
  import api from '@/services/api'
  import BundleModal from '@/components/BundleModal'
  import BundleServicesModal from '@/components/BundleServicesModal'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'
  import ConfirmModal from '@/components/ConfirmModal.vue'
  import _ from 'lodash'
  import BundleInsurancePatientAmountModal from '@/components/BundleInsurancePatientAmountModal.vue'

  export default {
    name: 'Bundles',

    components: { BundleInsurancePatientAmountModal, ConfirmModal, LoadingModal, Paginator, BundleModal, BundleServicesModal },

    mixins: [ErrorsMixin, AnalyticsMixin],

    data () {
      return {
        bundles: [],
        employers: [],
        showingBundleModal: false,
        showingServicesModal: false,
        showingLoadingModal: false,
        showingBundleInsurancePatientAmountModal: false,
        searchTerm: '',
        searchDebounceFn: null,
        episodeServiceModalTitle: 'Episode Services',
        totalPages: 0,
        currentPage: 1,
        pageSize: 20,
        isLoading: false,
        libraryPopoverShowing: false,
        employerOptions: [],
        selectedEmployerId: 0,
        employerIds: [],
        selectedEmployer: {},
        showingConfirmModal: false,
        sortBy: null,
        sortOrder: null,
        archivableBundle: {
          organizationBundleId: 0
        },
        editingBundle: {
          organizationBundleId: 0
        }
      }
    },

    watch: {
      currentPage (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.load()
        }
      },
      searchTerm (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      selectedEmployerId (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      selfPayBundles (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      }
    },

    computed: {
      selfPayBundles () {
        return this.selectedEmployerId < 0
      },
      title () {
        if (this.selfPayBundles === false && this.employer && this.employer.name) {
          return this.employer.name
        }
        return 'Self Pay'
      },

      bundleType () {
        if (this.selectedEmployerId < 0) {
          return 'SelfPay'
        } else {
          return 'Employer'
        }
      },
      employer () {
        return this.employers.find(e => e.organizationEmployerId === this.selectedEmployerId) || {}
      }
    },

    methods: {
      addBundle () {
        this.editingBundle = {
          organizationBundleId: 0
        }
        this.showingBundleModal = true
      },

      editBundle (bundle) {
        this.editingBundle = bundle
        this.showingBundleModal = true
      },

      bundleSaved () {
        this.showingBundleModal = false
        this.load()
      },

      editBundleServices (bundle) {
        this.episodeServiceModalTitle = 'Episode Services for ' + bundle.name
        this.editingBundle = bundle
        this.showingServicesModal = true
      },

      serviceSaved (changed) {
        this.showingServicesModal = false
      },
      insurancePatientAmountSaved () {
        this.showingBundleInsurancePatientAmountModal = false
      },

      editBundleInsurancePatientAmounts (bundle) {
        this.editingBundle = bundle
        this.showingBundleInsurancePatientAmountModal = true
      },

      load (silent = false) {
        this.clearAllErrors()
        if (!silent) {
          this.showingLoadingModal = true
        }

        if (this.isLoading) {
          return
        }

        const employerIds = []
        if (this.selectedEmployerId > 0) {
          employerIds.push(this.selectedEmployerId)
        }
        const parameters = {
          searchTerm: this.searchTerm,
          pageSize: this.pageSize,
          page: this.currentPage,
          employerIds,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          selfPayBundles: this.selfPayBundles
        }

        this.isLoading = true
        api.post('/Dashboard/Bundles', parameters).then(response => {
          this.trackEvent('Bundle', 'Load', 'ResponseTime', response.config.requestDuration)
          this.isLoading = false
          this.persistSettings()
          this.bundles = response.data.bundles
          this.currentPage = response.data.page
          this.logoUrl = response.data.logoUrl
          this.selectedEmployer = response.data.selectedEmployer
          if (response.data.selectedEmployer) {
            this.selectedEmployer = response.data.selectedEmployer
            this.selectedEmployerId = response.data.selectedEmployer.organizationEmployerId
          }
          this.totalPages = Math.ceil(response.data.totalBundles / this.pageSize)
          if (this.selectedEmployerId > 0 && this.bundles.length > 0) {
            this.logoUrl = this.bundles[0].employer.logoUrl
          } else {
            this.logoUrl = ''
          }
        }).catch(error => {
          this.isLoading = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Bundle', 'LoadError', error.message)
            this.$log.error('Error attempting to load bundles: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      sort (newOrder) {
        if (newOrder === this.sortBy) {
          if (this.sortOrder === 'Descending') {
            this.sortBy = null
            this.sortOrder = null
            this.load()

            return
          } else {
            this.sortOrder = 'Descending'
          }
        } else {
          this.sortOrder = 'Ascending'
        }

        this.sortBy = newOrder
        this.load()
      },
      sortIndicator (sortType) {
        if (sortType === this.sortBy) {
          if (this.sortOrder === 'Descending') {
            return '▼'
          } else {
            return '▲'
          }
        }

        return ''
      },

      displayCode (bundle) {
        if (bundle.modifier) {
          return bundle.code + '-' + bundle.modifier
        }

        return bundle.code
      },

      displayTerm (bundle) {
        if (bundle.durationDays === 0) {
          return 'DOS'
        } else {
          return bundle.durationDays + 'D'
        }
      },

      formatDate (date) {
        if (date) {
          return moment(date).format('MM/DD/YYYY')
        } else {
          return ''
        }
      },

      formatNumber (number) {
        if (number) {
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }

        return '0.00'
      },

      handleOrgChange (newOrg, event) {
        this.restoreSettings()
        this.load()
      },

      selectEpisodeLibrary () {
        this.libraryPopoverShowing = false
      },

      archiveConfirmed (confirmation) {
        this.showingConfirmModal = false
        if (confirmation === true && this.archivableBundle.organizationBundleId > 0) {
          this.archiveBundle(this.archivableBundle.organizationBundleId)
        }
        this.archivableBundle = {
          organizationBundleId: 0
        }
      },

      confirmArchive (bundle) {
        this.archivableBundle = bundle
        this.showingConfirmModal = true
      },

      archiveBundle (organizationBundleId) {
        this.clearAllErrors()
        api.post('/Dashboard/Organization/Bundles/' + organizationBundleId + '/BundleStatus/Archived').then(response => {
          this.trackEvent('Bundle', 'ArchiveBundles', 'ResponseTime', response.config.requestDuration)
          this.load()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Bundle', 'ArchiveError', error.message)
            this.$log.error('Error setting archived status: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      publishBundle (bundle) {
        this.clearAllErrors()
        this.showingLoadingModal = true
        bundle.status = 'PendingApproval'
        api.post('/Dashboard/Organization/Bundles/' + bundle.organizationBundleId + '/BundleStatus/' + bundle.status).then(response => {
          this.trackEvent('Bundle', 'PublishBundles', 'ResponseTime', response.config.requestDuration)
          this.load()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Bundle', 'PublishError', error.message)
            this.$log.error('Error setting published status: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      loadEmployers () {
        this.clearAllErrors()
        this.isLoading = true
        api.get('/Dashboard/Employers').then(response => {
          this.trackEvent('Bundle', 'LoadEmployers', 'ResponseTime', response.config.requestDuration)
          response.data.forEach(employer => {
            this.employerOptions.push({
              text: employer.name,
              value: employer.organizationEmployerId
            })
          })
          this.employerOptions.push({
            text: 'Self Pay',
            value: -1
          })
          this.employers = response.data
        }).catch(error => {
          this.isLoading = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Bundle', 'LoadEmployersError', error.message)
            this.$log.error('Error attempting to load employers: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        })
      },

      hideLibraryPopover () {
        if (this.libraryPopoverShowing) {
          this.$root.$emit('bv::hide::popover')
        }
      },
      persistSettings () {
        const bundleLibraryFilters = {
          employerIds: this.selectedEmployerId,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          searchTerm: this.searchTerm

        }
        localStorage.setItem('selectedBundleLibraryFilters', JSON.stringify(bundleLibraryFilters))
      },

      restoreSettings () {
        this.restoringSettings = true
        const settingBundleLibraryFilters = localStorage.getItem('selectedBundleLibraryFilters')
        if (settingBundleLibraryFilters) {
          const bundleLibraryFilters = JSON.parse(settingBundleLibraryFilters)
          if (bundleLibraryFilters.employerIds) {
            this.selectedEmployerId = bundleLibraryFilters.employerIds
          }
          if (bundleLibraryFilters.sortBy && bundleLibraryFilters.sortBy !== 'null') {
            this.sortBy = bundleLibraryFilters.sortBy
          }
          if (bundleLibraryFilters.sortOrder && bundleLibraryFilters.sortOrder !== 'null') {
            this.sortOrder = bundleLibraryFilters.sortOrder
          }
          if (bundleLibraryFilters.searchTerm) {
            this.searchTerm = bundleLibraryFilters.searchTerm
          }
        }
        this.$nextTick(() => {
          this.restoringSettings = false
        })
      }
    },

    created () {
      this.$store.$on('organization:changed', this.handleOrgChange)
      this.searchDebounceFn = _.debounce(() => {
        if (this.searchTerm === '') {
          this.totalPages = Math.ceil(this.bundles.totalBundles / this.pageSize)
          this.currentPage = 1
        } else {
          this.currentPage = 1
          this.totalPages = 0
        }
        this.load()
      }, 500)
      if (this.$store.isAuthenticated) {
        this.restoreSettings()
        this.load()
        this.loadEmployers()
      }
    }
  }
</script>

<style scoped>

.employer-logo {
  max-height: 94px;
  max-width: 94px;
}

.patient-search {
  min-width: 250px;
  height: 36px;
}

.filter-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
